import factory from '../requestFactory';
import store from '@/store'

export default () => {
    let params = {
        patient_id: store.getters.patient.id
    }
    return factory()
        .get('/patient/analyzes', {params:params})

};
